import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import Skeleton from '@v2/elements/Skeleton';

import { DASHBOARD_SUMMARY_CARD_CONFIG } from '@v2/pages/dashboard/common/components/DashboardSummary/constants';

interface DashboardSummarySkeletonProps extends WithColor {}

const DashboardSummarySkeleton: FC<DashboardSummarySkeletonProps> = ({ C }) => (
  <View style={{ gap: scale(DASHBOARD_SUMMARY_CARD_CONFIG.gap) }}>
    <View style={{ flexDirection: 'row', gap: scale(DASHBOARD_SUMMARY_CARD_CONFIG.gap) }}>
      <Skeleton C={C} width="100%" height={scale(DASHBOARD_SUMMARY_CARD_CONFIG.height)} borderRadius={scale(DASHBOARD_SUMMARY_CARD_CONFIG.radius)} style={{ flex: 1 }} />
      <Skeleton C={C} width="100%" height={scale(DASHBOARD_SUMMARY_CARD_CONFIG.height)} borderRadius={scale(DASHBOARD_SUMMARY_CARD_CONFIG.radius)} style={{ flex: 1 }} />
    </View>
    <Skeleton C={C} width="100%" height={scale(DASHBOARD_SUMMARY_CARD_CONFIG.height)} borderRadius={scale(DASHBOARD_SUMMARY_CARD_CONFIG.radius)} />
  </View>
);

export default ColorWrapper(DashboardSummarySkeleton);
